import MultiPicker from './multi-picker'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '123'
    },
    list: {
      type: Array,
      default: () => ([])
    },
    limitCount: {
      type: Object,
      default: () => ({})
    },
    complexMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
  },
  methods: {
    updateVisible(val) {
      this.visible = val
    },
    handleInput(val) {
      this.$emit('input', val)
    },
    handleClickButton() {
      this.visible = true
    }
  },
  render() {
    return (
      <div class="multi-picker-input-wrapper" onClick={(this.handleClickButton)}>
        {
          !this.complexMode || (this.complexMode && !this.value) ? (
            <span class="title">{this.title}</span>
          ) : null
        }
        <span class="value">{this.value}</span>
        <MultiPicker
          {...{
            on: {
              'update:visible': this.updateVisible,
              'input': this.handleInput
            }
          }}
          value={this.value}
          list={this.list}
          limitCount={this.limitCount}
          visible={this.visible} />
      </div>
    )
  }
}